import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";

import { firebaseConfig } from "./envConfig";

// Test-Easychaw for development
// const devFirebaseConfig = {
//   apiKey: "AIzaSyB10eXJUKuEv5i4lkv0rWeK3JrpveDHmOQ",
//   authDomain: "test-easychaw.firebaseapp.com",
//   databaseURL: "https://test-easychaw.firebaseio.com",
//   projectId: "test-easychaw",
//   storageBucket: "test-easychaw.appspot.com",
//   messagingSenderId: "48327216064",
//   appId: "1:48327216064:web:c01dae0d1d802e23451625",
//   measurementId: "G-RPBP07KBKG",
// };

// Config object
// const prodFirebaseConfig = {
//   apiKey: "AIzaSyBUQs-C3DV8iZ_NYSdjHN--g50yMETXXMY",
//   authDomain: "easychaw-2329c.firebaseapp.com",
//   databaseURL: "https://easychaw-2329c.firebaseio.com",
//   projectId: "easychaw-2329c",
//   storageBucket: "easychaw-2329c.appspot.com",
//   messagingSenderId: "444953583881",
//   appId: "1:444953583881:web:102ca13afbf5bb99c7f3d8",
//   measurementId: "G-6SZKWLW89M",
// };

// const firebaseConfig = {
//   ...prodFirebaseConfig,
//   // ...devFirebaseConfig,
// };

// Initialize firebase
firebase.initializeApp(firebaseConfig);
firebase.firestore().settings({ experimentalForceLongPolling: true });
firebase
  .firestore()
  .enablePersistence()
  .catch((error) => console.log(error));

export const GOOGLE_MAP = "AIzaSyBUQs-C3DV8iZ_NYSdjHN--g50yMETXXMY";
// export const GOOGLE_MAP = "AIzaSyBUuaoggR-HOkfgqI42zn41M5PegYAerbY";

export const timestamp = firebase.firestore.Timestamp;

export default firebase;
